import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api';

export default function SetPin() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [pin, setPin] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (pin.length !== 4) {
            toast.error("PIN must be 4 digits");
            return;
        }

        try {
            const response = await api.post('auth/set-pin/', { token, pin });

            if (response.status === 200) {
                toast.success('PIN set successfully! Please login.');
                const params = new URLSearchParams(window.location.search);
                const redirectTo = params.get('redirectTo');
                navigate(
                    redirectTo
                        ? `/login?redirectTo=${redirectTo}`
                        : '/login'
                );
            } else {
                toast.error(response.data.error || 'Failed to set PIN');
            }
        } catch (err) {
            if (err.response?.data?.error) {
                toast.error(err.response.data.error);
            } else {
                toast.error('An error occurred. Please try again.');
            }
        }
    };

    return (
        <div style={{ maxWidth: '400px', margin: '40px auto' }}>
            <h2>Create Your PIN</h2>
            <p style={{ marginBottom: '20px', color: '#666' }}>
                Create a 4-digit PIN to secure your account.
            </p>

            <form
                onSubmit={handleSubmit}
                style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}
            >
                <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>
                        4-Digit PIN
                    </label>

                    <input
                        type="text"
                        pattern="\d{4}"
                        maxLength="4"
                        value={pin}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val) && val.length <= 4) {
                                setPin(val);
                            }
                        }}
                        required
                        style={{
                            width: '100%',
                            padding: '8px',
                            fontSize: '18px',
                            letterSpacing: '2px',
                            textAlign: 'center'
                        }}
                        placeholder="0000"
                    />
                </div>

                <button type="submit" style={{ padding: '10px' }}>
                    Set PIN & Continue
                </button>
            </form>
        </div>
    );
}